import axios, { AxiosResponse } from "axios";
import { RequestStaffQueryString } from "../../models/dtos/management/RequestStaffQueryString";
import BaseService from "../base/BaseService";

export default class SupportUserService extends BaseService {

    requestStaff(request: RequestStaffQueryString): Promise<any> {
        return axios.post(`/Support/Users/RequestStaff`, request)
            .then(function (response: AxiosResponse<any>) {
                return response.data;
            });
    }

}